export default __webpack_public_path__ + "static/media/disco_bg.37420a77.jpg";